import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-firmware-update-dialog-v2',
    templateUrl: './firmware-update-dialog-v2.component.html',
    styleUrls: ['./firmware-update-dialog-v2.component.scss']
})
export class FirmwareUpdateDialogV2Component {
    dontShowAgain = false;

    constructor(private dialogRef: MatDialogRef<FirmwareUpdateDialogV2Component>) {}

    close() { this.dialogRef.close(this.dontShowAgain); }
}
